//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { get as getPath } from 'lodash-es';

export default {
  name: 'RadioInput',
  model: {
    prop: 'modelValue',
  },
  props: {
    id: {
      type: String,
      default: undefined,
    },
    label: {
      type: String,
      default: undefined,
    },
    name: {
      type: String,
      default: undefined,
    },
    value: {
      type: null,
      default: '',
    },
    modelValue: {
      type: null,
      default: '',
    },
    rules: {
      type: [String, Object],
      default: '',
    },
    showErrors: {
      type: Boolean,
      default: true,
    },
    trackBy: {
      type: String,
      default: undefined,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    reversed: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    checked() {
      if (this.trackBy) {
        return getPath(this.value, this.trackBy) === getPath(this.modelValue, this.trackBy);
      }

      return this.value === this.modelValue;
    },
  },
  methods: {
    onChange() {
      this.$emit('input', this.value);
    },
  },
};
